module.exports = __webpack_public_path__ + "7e075dd26b3dc8720161e70ce3a45a4e.jpg";